import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  User,
  Users,
  UsersRound,
  CreditCard,
  Wallet,
  Layers,
  List,
  Building2,
  Image,
  Ban,
  Plus,
  CheckCircle,
  Trophy,
  MapPin,
  DollarSign,
  Landmark,
  ThumbsUp,
  Heart,
  FileText,
  Flag,
  Hourglass,
  Key,
  BarChart3,
  Bell,
  ChevronDown,
  TrendingUp,
  PieChart,
  Activity,
  Minus,
  LogOut,
  Gavel,
  ClipboardClock,
  Undo2,
  Truck,
  Forklift,
  Gauge,
  ListPlus,
  WalletMinimal,
  BanknoteArrowDown,
  ClipboardList,
} from 'lucide-react';
import i18n from '../../i18n';
import { getLoggedUser } from '../../state/user';
import { getNotificationCounts } from '../../models/payments';
import { SideBarMob } from './sidebar-mob';
import { getUserInfo } from '../../models/users';
import { generateMzadcomID } from '../../state/utils';
import '../../styles/components/sidebar.scss';

const user = getLoggedUser();
let is_logged = localStorage.getItem('is_logged_in') ? true : false;
const allowed_roles = ['F', 'U'];

function logout() {
  localStorage.clear();
  window.location.href = '/';
}

export class SideBar extends React.Component {
  constructor() {
    super();
    this.state = {
      dashboard_menu_expand: true,
      report_menu_expand: true,
      wallet_amount: 0,
      pendingMzadcomPayment: 0,
      pendingSupplierPayment: 0,
      pendingAuctionPayment: 0,
    };
    this.notificationCheck = this.notificationCheck.bind(this);
  }

  componentDidMount() {
    if (user && allowed_roles.includes(user.role) ? true : false) {
      this.notificationCheck();
      setInterval(() => {
        this.notificationCheck();
      }, 60000);
    }
  }

  async checkUserWallet() {
    this.setState({ is_loading: true });
    const response = await getUserInfo(user.id);
    if (response && response.success) {
      let data = response.data;
      this.setState({ is_loading: false });
      this.setState({ wallet_amount: data.wallet_amount });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async notificationCheck() {
    let response = await getNotificationCounts();
    let data = response.data;
    this.setState({
      pendingMzadcomPayment: data.mzadcom_payment_count,
      pendingSupplierPayment: data.supplier_auction_count,
      pendingAuctionPayment: data.auction_payment_count,
    });
  }
  toggleDashboardMenu = () => {
    this.setState({
      dashboard_menu_expand: !this.state.dashboard_menu_expand,
    });
  };
  toggleReportMenu = () => {
    this.setState({
      report_menu_expand: !this.state.report_menu_expand,
    });
  };
  render() {
    const { count, wallet_amount, dashboard_menu_expand, report_menu_expand } = this.state;

    return (
      <React.Fragment>
        {is_logged && (
          <div>
            {/* Dashboard Tab Mobile */}
            <SideBarMob wallet_amount={wallet_amount} />
            <div class=" d-mob-none">
              <div className="professional-sidebar">
                {/* Dashboard Header */}
                <div className="sidebar-dashboard-header">
                  <LayoutDashboard className="dashboard-icon" size={20} />
                  <span className="dashboard-title">{i18n.t('dashboard')}</span>
                </div>
                {/* User Profile Card */}
                <UserProfileCard user={user} i18n={i18n} generateMzadcomID={generateMzadcomID} />

                {/* Navigation Menu */}
                <nav className="sidebar-navigation">
                  {/* Management Dashboard */}
                  {['CE', 'GM'].includes(user.role) && (
                    <NavLink to="/management" className="nav-item">
                      <TrendingUp className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('management_dashboard')}</span>
                    </NavLink>
                  )}

                  {['CE', 'GM', 'F'].includes(user.role) && (
                    <NavLink to="/cash-flow" className="nav-item">
                      <BarChart3 className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('mzadcom_cash_flow_dashboard')}</span>
                    </NavLink>
                  )}

                  {/* Dashboard */}
                  {['U', 'CE', 'GM'].includes(user.role) && (
                    <NavLink to="/dashboard" className="nav-item">
                      <LayoutDashboard className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('dashboard')}</span>
                    </NavLink>
                  )}

                  {(user.role === 'CE' || user.role === 'GM') && (
                    <>
                      <NavLink to="/loading-progress" className="nav-item">
                        <Gauge className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('loading_progress')}</span>
                      </NavLink>
                    </>
                  )}

                  {/* Client Dashboard */}
                  {['C'].includes(user.role) && (
                    <NavLink to="/client-dashboard" className="nav-item">
                      <LayoutDashboard className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('dashboard')}</span>
                    </NavLink>
                  )}
                  {user.role === 'C' && (
                    <>
                      <NavLink to="/client-account-config" className="nav-item">
                        <Landmark className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('bank_account_config')}</span>
                      </NavLink>
                    </>
                  )}

                  {['C'].includes(user.role) && (
                    <NavLink to="/loading-progress" className="nav-item">
                      <Gauge className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('loading_progress')}</span>
                    </NavLink>
                  )}

                  {/* Dashboard with Submenu */}
                  {!['U', 'C', 'CE', 'GM', 'O'].includes(user.role) && (
                    <div className="nav-group">
                      <button className="nav-item nav-expandable" onClick={this.toggleDashboardMenu}>
                        <LayoutDashboard className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('dashboard')}</span>
                        <ChevronDown className={`expand-icon ${dashboard_menu_expand ? 'expanded' : ''}`} size={16} />
                      </button>
                      <div className={`nav-submenu ${dashboard_menu_expand ? 'show' : ''}`}>
                        <NavLink to="/dashboard" className="nav-subitem">
                          <Activity className="nav-icon-svg" strokeWidth={2} size={16} />
                          <span className="nav-label">{i18n.t('live_dashboard')}</span>
                        </NavLink>
                        <NavLink to="/dashboard-auc-eval" className="nav-subitem">
                          <PieChart className="nav-icon-svg" strokeWidth={2} size={16} />
                          <span className="nav-label">{i18n.t('auction_evaluation')}</span>
                        </NavLink>
                        <NavLink to="/dashboard-user-analysis" className="nav-subitem">
                          <Users className="nav-icon-svg" strokeWidth={2} size={16} />
                          <span className="nav-label">{i18n.t('user_analysis')}</span>
                        </NavLink>
                        <NavLink to="/dashboard-sales-eval" className="nav-subitem">
                          <TrendingUp className="nav-icon-svg" strokeWidth={2} size={16} />
                          <span className="nav-label">{i18n.t('sales_evaluation')}</span>
                        </NavLink>
                      </div>
                    </div>
                  )}

                  {/* Profile */}
                  <NavLink to="/profile" className="nav-item">
                    <User className="nav-icon-svg" strokeWidth={2} />
                    <span className="nav-label">{i18n.t('edit_profile')}</span>
                  </NavLink>

                  {/* Admin/Manager Sections */}
                  {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'F' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'M') && (
                    <>
                      <NavLink to="/users" className="nav-item">
                        <Users className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('users')}</span>
                      </NavLink>
                    </>
                  )}

                  {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'M') && (
                    <>
                      <NavLink to="/clients" className="nav-item">
                        <UsersRound className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('clients')}</span>
                      </NavLink>
                    </>
                  )}
                  {['A'].includes(user.role) && (
                    <NavLink to="/organizations" className="nav-item">
                      <Building2 className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('organizations')}</span>
                    </NavLink>
                  )}

                  {/* Enrolled Users */}
                  {/* {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'F' ||
                    user.role === 'M') && (
                    <NavLink to="/enrolled_users" className="nav-item">
                      <UserPlus className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('enrolled_users')}</span>
                    </NavLink>
                  )} */}

                  {/* Finance Sections */}
                  {['F', 'PM'].includes(user.role) && (
                    <NavLink to="/auction-payment" className="nav-item">
                      <CreditCard className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('auction_payments')}</span>
                      {user.role === 'F' && this.state.pendingAuctionPayment > 0 && (
                        <span className="count-badge">{this.state.pendingAuctionPayment}</span>
                      )}
                    </NavLink>
                  )}

                  {/* NEW MZADCOM TRANSACTION SUMMARY */}
                  {['A', 'F', 'CE', 'GM'].includes(user.role) && (
                    <NavLink to="/mzadcom-transactions-summary" className="nav-item">
                      <Wallet className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">
                        {i18n.t('mzadcom')} - {i18n.t('transactions')}
                      </span>
                    </NavLink>
                  )}

                  {/* Wallet Management */}
                  {['A', 'F', 'CE', 'GM'].includes(user.role) && (
                    <>
                      {/* <NavLink to="/users-wallet" className="nav-item">
                        <Wallet className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">
                          {i18n.t('mzadcom')} - {i18n.t('wallet')}
                        </span>
                      </NavLink> */}
                      {/* <NavLink to="/withdraw-requests" className="nav-item">
                        <RotateCcw className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('withdraw_requests')}</span>
                      </NavLink> */}

                      <NavLink to="/recharge-requests" className="nav-item">
                        <WalletMinimal className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('recharge_requests')}</span>
                      </NavLink>
                      <NavLink to="/withdrawal-requests" className="nav-item">
                        <BanknoteArrowDown className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('withdrawal_requests')}</span>
                      </NavLink>
                    </>
                  )}

                  {['C', 'A', 'PM', 'OM', 'GM', 'CE', 'F'].includes(user.role) && (
                    <NavLink to="/enrollments/list" className="nav-item">
                      <ClipboardList className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('enrollment_list')}</span>
                    </NavLink>
                  )}
                  {['C', 'A', 'PM', 'OM', 'GM', 'CE', 'F'].includes(user.role) && (
                    <NavLink to="/enrollments/refund/list" className="nav-item">
                      <Undo2 className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('refund_list')}</span>
                      {allowed_roles.includes(user.role) && count > 0 && (
                        <span className="notification-badge">{count}</span>
                      )}
                    </NavLink>
                  )}
                  {/* Auction Approval */}
                  {(user.role === 'C' || user.role === 'PM' || user.role === 'OM' || user.role === 'F') && (
                    <NavLink to="/auction_approval" className="nav-item">
                      <ClipboardClock className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">
                        {user.role === 'F' ? i18n.t('supplier_payment') : i18n.t('auction_approval')}
                      </span>
                      {user.role === 'F' && this.state.pendingSupplierPayment > 0 && (
                        <span className="count-badge">{this.state.pendingSupplierPayment}</span>
                      )}
                    </NavLink>
                  )}
                  {/* Finance Sections */}
                  {['A', 'F'].includes(user.role) && (
                    <NavLink to="/groups" className="nav-item">
                      <Layers className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('groups')}</span>
                    </NavLink>
                  )}
                  {/* Auctions List */}
                  {(user.role === 'A' ||
                    user.role === 'C' ||
                    user.role === 'PM' ||
                    user.role === 'F' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'M') && (
                    <NavLink to="/auctions-list" className="nav-item">
                      <Gavel className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('auctions')}</span>
                    </NavLink>
                  )}
                  {/* Admin Only Sections */}
                  {user.role === 'A' && (
                    <>
                      <NavLink to="/auction/create" className="nav-item">
                        <Plus className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('create_auction')}</span>
                      </NavLink>
                      <NavLink to="/masks" className="nav-item">
                        <Layers className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('masks')}</span>
                      </NavLink>
                      <NavLink to="/categories" className="nav-item">
                        <List className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('categories')}</span>
                      </NavLink>

                      <NavLink to="/mzadcom-bank-accounts" className="nav-item">
                        <Landmark className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('bank_account_config')}</span>
                      </NavLink>
                      <NavLink to="/banners" className="nav-item">
                        <Image className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('banners')}</span>
                      </NavLink>
                      <NavLink to="/blacklist" className="nav-item">
                        <Ban className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('blacklist')}</span>
                      </NavLink>

                      <NavLink to="/attributes/create" className="nav-item">
                        <ListPlus className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('attributes')}</span>
                      </NavLink>
                    </>
                  )}

                  {user.role === 'A' && (
                    <NavLink to="/approved_auctions" className="nav-item">
                      <CheckCircle className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('approved_auctions')}</span>
                    </NavLink>
                  )}

                  {/* User Specific */}
                  {user.role === 'U' && (
                    <>
                      <NavLink to="/my_auctions" className="nav-item">
                        <Key className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('my_bids')}</span>
                      </NavLink>
                      <NavLink to="/enrolled_auctions" className="nav-item">
                        <FileText className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('enrolled_auctions')}</span>
                      </NavLink>
                      <NavLink to="/winning_bids" className="nav-item">
                        <Trophy className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('winning_bids')}</span>
                      </NavLink>
                      <NavLink to="/mzadcom-payment" className="nav-item">
                        <CreditCard className="nav-icon-svg" />
                        <span className="nav-label">{i18n.t('mzadcom_payment')}</span>
                        {this.state.pendingMzadcomPayment > 0 && (
                          <span className="count-badge">{this.state.pendingMzadcomPayment}</span>
                        )}
                      </NavLink>
                    </>
                  )}

                  {/* Site Visit */}

                  {(user.role === 'HSE' || user.role === 'PM' || user.role === 'O' || user.role === 'GM') && (
                    <>
                      <NavLink to="/loading-management" className="nav-item">
                        <Forklift className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('loading_management')}</span>
                      </NavLink>

                      <NavLink to="/vehicles" className="nav-item">
                        <Truck className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('vehicles')}</span>
                      </NavLink>

                      {/* <NavLink to="/delivery-schedule-list" className="nav-item">
                        <List className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('delivery_schedule_list')}</span>
                      </NavLink> */}

                      <NavLink to="/delivery-site-list" className="nav-item">
                        <List className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('delivery_site_list')}</span>
                      </NavLink>

                      <NavLink to="/weighbridge-ticket-list" className="nav-item">
                        <List className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('weighbridge_ticket_list')}</span>
                      </NavLink>

                      <NavLink to="/site-visit-projects" className="nav-item">
                        <MapPin className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('site_visit_projects')}</span>
                      </NavLink>

                      <NavLink to="/site-visit-requests" className="nav-item">
                        <MapPin className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('site_visit_req')}</span>
                      </NavLink>
                    </>
                  )}

                  {!['C'].includes(user.role) && (
                    <NavLink to="/site_visit" className="nav-item">
                      <MapPin className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('site_visit')}</span>
                    </NavLink>
                  )}

                  {/* Wallet */}
                  {user.role === 'U' && (
                    <NavLink to="/wallet" className="nav-item">
                      <Wallet className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('my_wallet')}</span>
                    </NavLink>
                  )}

                  {/* Payments */}
                  {(user.role === 'A' || user.role === 'M') && (
                    <NavLink to="/payments" className="nav-item">
                      <CreditCard className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('payment')}</span>
                    </NavLink>
                  )}

                  {(user.role === 'A' || user.role === 'PM' || user.role === 'OM') && (
                    <NavLink to="/client-payments" className="nav-item">
                      <Landmark className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('client_payment')}</span>
                    </NavLink>
                  )}

                  {/* Refund */}
                  {/* {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'F' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE') && (
                    <NavLink to="/refund" className="nav-item">
                      <Undo2 className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('refund')}</span>
                      {allowed_roles.includes(user.role) && count > 0 && (
                        <span className="notification-badge">{count}</span>
                      )}
                    </NavLink>
                  )} */}

                  {/* Liked Auctions */}

                  {user.role === 'U' && (
                    <>
                      <NavLink to="/auction/liked" className="nav-item">
                        <ThumbsUp className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('liked_auctions')}</span>
                      </NavLink>

                      <NavLink to="/auction/wishlist" className="nav-item">
                        <Heart className="nav-icon-svg" strokeWidth={2} />
                        <span className="nav-label">{i18n.t('wishlisted_auctions')}</span>
                      </NavLink>
                    </>
                  )}

                  {/* Reports */}
                  {(user.role === 'A' ||
                    user.role === 'C' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'M' ||
                    user.role === 'F') && (
                    <div className="nav-group">
                      <button className="nav-item nav-expandable" onClick={this.toggleReportMenu}>
                        {report_menu_expand ? (
                          <Minus className="nav-icon-svg" strokeWidth={2} />
                        ) : (
                          <Plus className="nav-icon-svg" strokeWidth={2} />
                        )}
                        <span className="nav-label">{i18n.t('reports')}</span>
                        <ChevronDown className={`expand-icon ${report_menu_expand ? 'expanded' : ''}`} size={16} />
                      </button>
                      <div className={`nav-submenu ${report_menu_expand ? 'show' : ''}`}>
                        {(user.role === 'A' ||
                          user.role === 'C' ||
                          user.role === 'PM' ||
                          user.role === 'OM' ||
                          user.role === 'GM' ||
                          user.role === 'CE' ||
                          user.role === 'M') && (
                          <>
                            <NavLink to="/auction_bid_report" className="nav-subitem">
                              <FileText className="nav-icon-svg" strokeWidth={2} size={16} />
                              <span className="nav-label">{i18n.t('auction_bid_report')}</span>
                            </NavLink>
                            <NavLink to="/winners" className="nav-subitem">
                              <Flag className="nav-icon-svg" strokeWidth={2} size={16} />
                              <span className="nav-label">{i18n.t('auction_winners')}</span>
                            </NavLink>
                            <NavLink to="/sales_report" className="nav-subitem">
                              <DollarSign className="nav-icon-svg" strokeWidth={2} size={16} />
                              <span className="nav-label">{i18n.t('sales_report')}</span>
                            </NavLink>
                            <NavLink to="/final_report" className="nav-subitem">
                              <Hourglass className="nav-icon-svg" strokeWidth={2} size={16} />
                              <span className="nav-label">{i18n.t('final_report')}</span>
                            </NavLink>

                            <NavLink to="/reports" className="nav-subitem">
                              <BarChart3 className="nav-icon-svg" strokeWidth={2} size={16} />
                              <span className="nav-label">{i18n.t('reports')}</span>
                            </NavLink>
                          </>
                        )}
                        {(user.role === 'A' ||
                          user.role === 'C' ||
                          user.role === 'PM' ||
                          user.role === 'OM' ||
                          user.role === 'GM' ||
                          user.role === 'CE' ||
                          user.role === 'M' ||
                          user.role === 'F') && (
                          <>
                            <NavLink to="/position_report" className="nav-subitem">
                              <Key className="nav-icon-svg" strokeWidth={2} size={16} />
                              <span className="nav-label">{i18n.t('position_report')}</span>
                            </NavLink>
                            <NavLink to="/wallet_summary" className="nav-subitem">
                              <Wallet className="nav-icon-svg" strokeWidth={2} size={16} />
                              <span className="nav-label">{i18n.t('wallet_summary')}</span>
                            </NavLink>
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Composer */}
                  {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'M') && (
                    <NavLink to="/composer" className="nav-item">
                      <Bell className="nav-icon-svg" strokeWidth={2} />
                      <span className="nav-label">{i18n.t('composer')}</span>
                    </NavLink>
                  )}

                  {/* Logout */}
                  <button onClick={logout} className="nav-item nav-logout">
                    <LogOut className="nav-icon-svg" strokeWidth={2} />
                    <span className="nav-label">{i18n.t('logout')}</span>
                  </button>
                </nav>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
// Simple User Profile Card Component with SVG Icons

const UserProfileCard = ({ user, i18n, generateMzadcomID }) => {
  return (
    <div className="sidebar-profile-card">
      <div className="profile-header-section">
        <div className="profile-avatar-wrapper">
          {user.avatar ? (
            <img src={user.avatar} alt={user.name} className="profile-avatar-image" referrerPolicy="no-referrer" />
          ) : (
            <div className="profile-avatar-placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
              </svg>
            </div>
          )}
        </div>
        <div className="profile-info-wrapper">
          <div className="profile-user-name">{user.name}</div>
          <div className="profile-user-email">{user.email}</div>
        </div>
      </div>

      <div className="profile-divider"></div>

      <div className="profile-details-grid">
        <div className="profile-detail-item">
          <svg viewBox="0 0 24 24" fill="currentColor" className="detail-icon">
            <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z" />
          </svg>
          <div className="detail-content">
            <span className="detail-label">{i18n.t('mobile')}</span>
            <span className="detail-value">{user.mobile}</span>
          </div>
        </div>

        <div className="profile-detail-item">
          <svg viewBox="0 0 24 24" fill="currentColor" className="detail-icon">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
          </svg>
          <div className="detail-content">
            <span className="detail-label">{i18n.t('mzadcom_id')}</span>
            <span className="detail-value">{generateMzadcomID(user.id, user.role)}</span>
          </div>
        </div>

        <div className="profile-detail-item">
          <svg viewBox="0 0 24 24" fill="currentColor" className="detail-icon">
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
          </svg>
          <div className="detail-content">
            <span className="detail-label">{i18n.t('email')}</span>
            <span className="detail-value">{user.email}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileCard;
